import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            width: '100%',
            maxWidth: 'container.xxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingX: {base: remCalc(16), '2xl': 0},
            paddingY: {base: remCalc(24), lg: remCalc(32)},
            overflowX: 'auto',
            flexShrink: 0,
            flexDir: 'column',
        },
        innerContainer: {
            width: '100%',
            flexDir: 'column',
        },
        productsContainer: {
            flexDir: {base: 'column', lg: 'row'},
            alignItems: 'center',
            justifyContent: {base: 'center', lg: 'flex-start'},
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        headerLabel: {
            paddingY: {base: remCalc(24), lg: remCalc(32)},
            paddingRight: {
                base: remCalc(16),
                md: 0,
            },
            position: 'sticky',
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        bundleCard: {
            flexDir: {base: 'row', lg: 'column'},
            alignItems: 'center',
            justifyContent: 'center',
            w: {base: remCalc(327), lg: remCalc(291)},
            h: {base: 'auto', lg: remCalc(344)},
            backgroundColor: 'background.default',
            borderRadius: {base: remCalc(8), lg: remCalc(16)},
            paddingX: {base: remCalc(8), lg: remCalc(16)},
            paddingY: {base: remCalc(4), lg: remCalc(24)},
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        firstBundleCard: {
            w: {base: remCalc(327), lg: remCalc(342.5)},
            h: {base: 'auto', lg: remCalc(420)},
        },
        plusIconContainer: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
        },
        plusIcon: {
            boxSize: {base: remCalc(15), lg: remCalc(25)},
        },
        productDetailsContainer: {
            flexDir: {base: 'row', lg: 'column'},
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: {base: remCalc(8), lg: remCalc(16)},
            flex: '1 0 0',
            fontWeight: 'normal',
            backgroundColor: 'background.default',
            width: {base: `calc(100% - ${remCalc(120)})`, lg: '100%'},
        },
        productDetailId: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        productDetailNameContainer: {
            w: {base: '100%', lg: '84%'},
        },
        productDetailName: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            'text-wrap': 'auto',
            textAlign: {base: 'left', lg: 'center'},
            noOfLines: {base: 2, lg: 1},
            textOverflow: 'ellipsis',
            fontWeight: 'medium',
            display: {base: '-webkit-box', lg: 'block'},
            whiteSpace: {base: 'normal', lg: 'nowrap'},
        },
        subtotalPrice: {
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            paddingY: {base: remCalc(16), lg: remCalc(0)},
            alignItems: 'center',
            fontWeight: 'medium',
            textStyle: {base: 'head-xsmall', lg: 'head-small'},
        },
        discountAndPriceContainer: {
            flexDir: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
            gap: remCalc(4),
        },
        bundleDiscountLabel: {
            display: {base: 'none', lg: 'flex'},
            padding: `${remCalc(2)} ${remCalc(4)}`,
            backgroundColor: 'label.background.secondary',
            color: 'label.text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        bundleDiscountLabelMobile: {
            display: {base: 'flex', lg: 'none'},
            padding: `${remCalc(2)} ${remCalc(4)}`,
            backgroundColor: 'label.background.secondary',
            color: 'label.text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        bundleImageContainer: {
            w: {base: remCalc(85), lg: '100%'},
            h: '100%',
            alignItems: 'center',
            justifyContent: 'center',
        },
        productTileImage: {
            h: '100%',
            objectFit: 'contain',
            borderRadius: {base: remCalc(0), lg: remCalc(16)},
        },
        bundleFreeGiftLabel: {
            backgroundColor: '#0C2340',
            color: 'white',
            padding: '6px 8px',
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
        },
        productPriceContainer: {
            flexDir: {base: 'column', lg: 'row'},
            w: {base: '100%', lg: 'auto'},
            alignItems: {base: 'flex-end', lg: 'center'},
            gap: {base: remCalc(5), lg: remCalc(10)},
        },
        productDetailPrice: {
            textStyle: 'body-xlarge',
            color: 'text.default',
            fontWeight: 'normal',
            order: 2,
            marginLeft: remCalc(6),
        },
        productListPrice: {
            textStyle: 'body-large',
            color: 'text.secondary',
            fontWeight: 'normal',
            order: 1,
        },
        addCartButtonContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            justifyContent: 'flex-end',
            paddingTop: {base: remCalc(0), lg: remCalc(40)},
        },
        divider: {
            display: {base: 'block', lg: 'none'},
            w: '100%',
            color: 'border.light',
        },
        addCartButton: {
            w: {base: '100%', lg: remCalc(213)},
        },
        cartBundleContainer: {
            w: 'auto',
            height: 'auto',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {base: remCalc(16), lg: remCalc(24)},
            minWidth: {base: remCalc(150), lg: remCalc(476)},
            border: '2px solid #D4D4D4',
            borderRadius: 'medium.lg',
        },
        cartHeaderContainer: {
            backgroundColor: 'background.light',
            w: '100%',
            padding: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            display: 'flex',
            justifyContent: 'space-between',
        },
        cartHeaderInfoContainer: {
            display: 'flex',
            flexDirection: 'column',
        },
        cartHeaderPriceContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(16),
        },
        cartBundleName: {
            textStyle: 'body-xxlarge',
            fontWeight: 'normal',
        },
        cartBundleItemContainer: {
            w: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            gap: {base: remCalc(24), lg: remCalc(26)},
            bg: 'background.default',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingBottom: {base: remCalc(20), lg: 0},
            paddingRight: remCalc(8),
        },
        cartBundleItemImage: {
            width: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
            height: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
        },
        cartItemDetailContainer: {
            display: 'flex',
            w: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        cartItemHeaderStack: {
            display: 'flex',
            justifyContent: 'space-between',
            alignSelf: 'stretch',
        },
        cartItemOmniAndPrice: {
            display: 'flex',
            flexDir: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: remCalc(8),
            flexWrap: 'wrap',
        },
        cartItemVatDetails: {
            display: 'flex',
            width: {
                lg: remCalc(164),
                md: remCalc(164),
            },
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: remCalc(10),
        },
        cartItemName: {
            flex: '1 0 0',
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
        },
        cartItemPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        cartSuggestedPrice: {
            textAlign: 'left',
            textDecorationLine: 'line-through',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        cartSuggestedText: {
            textAlign: 'left',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        infoLabelContainer: {
            flexDir: 'row',
            gap: 'xsmall.base',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
    },
}
